import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { VisionService } from '../services/vision.service';
import { SpinnerService } from '../services/spinner';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { VisionModel } from '../models/vision.model';
import { Observable } from 'rxjs/Observable';
import { SurveyTypes } from '../models/surveytypes';


@Component({
    selector: 'app-vision.criterias-edit',
    templateUrl: './vision.criterias_edit.component.html',
    styleUrls: ['./vision.criterias_edit.component.scss']
})
export class VisionCriteriasEditComponent implements OnInit {
    returnData: any;
    currentSurvey: any;
    visionId: string;
    visionTitle: string;
    newSurveyTitle: string;
    surveyTypeId: number;
    visionData: SurveyDetails;
    criteriasCount = 0;
    criterias1: Array<CriteriaDetails>;
    criterias2: Array<CriteriaDetails>;
    criterias3: Array<CriteriaDetails>;
    criterias4: Array<CriteriaDetails>;
    changeVisionType = false;

    constructor(private visionService: VisionService, private router: Router, private route: ActivatedRoute,
        private visionModel: VisionModel, private surveyTypes: SurveyTypes, private spinnerService: SpinnerService) {
        this.currentSurvey = JSON.parse(localStorage.getItem('current_survey'));
    }

    ngOnInit() {
        this.spinnerService.show();
        this.route.params.subscribe(params => {
            if (params['visiontype']) {
                this.surveyTypeId = params['visiontype'];
                this.changeVisionType = true;
            }
        });
        if (this.changeVisionType) {
            this.newSurveyTitle = this.surveyTypes.getTitle(this.surveyTypeId);
            // change current vision
            this.changeCurrentSurvey(this.surveyTypeId);
        }
        this.loadSurvey();
    }

    getCriteriasOfType(importance: number) {
        const criterias = this.visionData.criterias.filter(x => x.importance === importance);
        if (criterias) {
            return criterias;
        }
        return [];
    }

    loadSurvey() {
        if (!this.currentSurvey || this.currentSurvey === 'null') {
            const visionTypeId = this.visionModel.getCurrentSurveyTypeId();
            this.visionModel.setSurveyInStorageFromType(visionTypeId).subscribe(result => {
                this.currentSurvey = JSON.parse(localStorage.getItem('current_survey'));
            });
        } else {
            this.visionTitle = this.currentSurvey.title;
        }
        // delay and call data
        this.getData();
        this.spinnerService.hide();
    }
    getData() {
        if (this.currentSurvey) {
            this.visionId = this.currentSurvey.id;
            this.visionService.getVisionData(this.visionId).subscribe(result => {
                this.visionData = result.Survey;
                this.criteriasCount = this.visionData.criterias.length;
                this.criterias1 = this.getCriteriasOfType(1);
                this.criterias2 = this.getCriteriasOfType(2);
                this.criterias3 = this.getCriteriasOfType(3);
                this.criterias4 = this.getCriteriasOfType(4);
            });
        }
    }

    enregister() {
        this.router.navigateByUrl('vision/editcriterias');
    }

    changeCurrentSurvey(visionType) {
        // check if vision available to add
        this.visionModel.setSurveyInStorageFromType(visionType).subscribe(result => {
            // change current vision localstorage values
            this.currentSurvey = JSON.parse(localStorage.getItem('current_survey'));
            localStorage.setItem('vision_title', this.newSurveyTitle);
            this.visionTitle = this.newSurveyTitle;
            this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
            this.loadSurvey();
        });
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/vision/vision.criterias-edit.component.ts